import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"m16.134 9.774-7.543 7.543 1.68 1.679 7.541-7.543a2.764 2.764 0 0 0 0-3.906L10.27 0 8.591 1.68l7.543 7.546a.387.387 0 0 1 0 .548\"></path><path d=\"m.72 17.317 1.68 1.679 8.656-8.656a1.185 1.185 0 0 0 0-1.68L2.4 0 .72 1.68 8.537 9.5z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M19 19H0V0h19z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }